export interface FormatTags {
    index: number;
    tagType: string;
    properties: Record<string, string | number> | unknown;
}

const STYLE_CLASSES: Record<string, string> = {
    "list-style-type:disc": "bulleted",
};

const buildListAttributes = (rawListStyle?: string) => {
    if (!rawListStyle) {
        return "";
    }

    const styles = rawListStyle
        .split(";")
        .map((s) => s.trim())
        .filter(Boolean);

    const classes: string[] = [];
    const inline: string[] = [];

    for (const style of styles) {
        const normalized = style.replace(/;$/, "").trim();
        const className = STYLE_CLASSES[normalized];

        if (className) {
            classes.push(className);
        } else {
            inline.push(normalized);
        }
    }

    let result = "";

    if (classes.length) {
        result += ` class="${classes.join(" ")}"`;
    }

    if (inline.length) {
        result += ` style="${inline.join(";")};"`;
    }

    return result;
};

const HtmlTags: Record<string, string | ((props: Record<string, string | number>) => string)> = {
    HeaderBegin: "<h4 class='matchesColor'>",
    HeaderEnd: "</h4>",
    ListBegin: (props) => {
        const attributes = buildListAttributes(props?.listStyle as string | undefined);
        return `<ul${attributes}>`;
    },

    ListEnd: "</ul>",
    ListItemBegin: "<li>",
    BoldBegin: "<b>",
    BoldEnd: "</b>",
    ListItemEnd: "</li>",
    ParagraphBegin: "<p>",
    ParagraphEnd: "</p>",
    NewLine: "<br>",
};

export const getValidIndexNumber = (tag: FormatTags): number => tag.index ?? 0;

const getHtmlString = ({ message, formatTags }: { message?: string; formatTags?: FormatTags[] }): string => {
    if (!message) return "";
    if (!formatTags?.length) return message;

    const processedTags = new Set<FormatTags>();
    let text = message;
    let offset = 0;

    formatTags.forEach((tag) => {
        if (processedTags.has(tag)) return;

        const tagIndex = getValidIndexNumber(tag);
        const samePositionTags = formatTags.filter((t) => getValidIndexNumber(t) === tagIndex);

        samePositionTags.forEach((t) => {
            processedTags.add(t);
            const { tagType, properties } = t;
            if (tagType && tagType in HtmlTags) {
                const tagDef = HtmlTags[tagType];
                if (!tagDef) return;
                const htmlTag =
                    typeof tagDef === "function"
                        ? tagDef((properties as Record<string, string | number>) ?? {})
                        : tagDef;
                text = text.slice(0, tagIndex + offset) + htmlTag + text.slice(tagIndex + offset);
                offset += htmlTag.length;
            }
        });
    });

    return text;
};

export { getHtmlString };
